import cn from 'classnames'
import './styles.less'

export default function MessageComposerHints({ isComposerFocused }) {
  return (
    <div
      className={cn('mx_MessageComposer_hints', {
        focused: isComposerFocused,
      })}
    >
      <div>
        <strong>Return</strong> to send
      </div>
      <div className="hide-when-small">
        <strong>Shift+Return</strong> to add a new line
      </div>
      <div>
        <strong>**</strong> To leave a note<span className="hide-when-small">
          {' '}
          (only visible to {app.t('agents')})
        </span>
      </div>
    </div>
  )
}
